import React, { useMemo } from 'react';
import { ListItem, ListItemText } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useMessage } from 'modules/intl';
import CircularAnimation from './CircularAnimation';

const useStyles = makeStyles((theme) => ({
  avatar: {
    backgroundColor: theme.palette.success.main,
    width: theme.spacing(4),
    height: theme.spacing(4)
  },
  menuText: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    color: theme.palette.text.secondary,
    ...theme.typography.body2,
    marginLeft: theme.spacing(1.5)
  },
  iconButton: {
    padding: 0
  }
}));

export const AutoPilotEnabled: React.FC = () => {
  const classes = useStyles();
  const listItemTextClasses = useMemo(
    () => ({
      primary: classes.menuText
    }),
    [classes.menuText]
  );

  const autoPilotEnabled = useMessage('autoPilot.autoPilotEnabled');

  return (
    <ListItem
      id="auto-pilot-element"
      dense={false}
      aria-readonly
      data-testid="auto-pilot-element"
    >
      <div>
        <CircularAnimation />
      </div>
      <ListItemText
        primary={autoPilotEnabled}
        classes={listItemTextClasses}
        data-testid="auto-pilot-text"
      />
    </ListItem>
  );
};

export default AutoPilotEnabled;
